import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from '@weezevent/nacre';
import Style from './customize_url.module.css';

export default function CustomizeUrl({ baseUrl, form, setForm, formErrors }) {
    const { t } = useTranslation();
    const [valueLength, setValueLength] = React.useState(form.widget_key.length || 0);

    const maxLength = 60;

    const handleChange = ({ target: { value } }) => {
        setForm('widget_key', value);
        setValueLength(value.length);
    };

    return (
        <Form.Field>
            <Form.Label label={t('ticket.personal_spaces.create.widget_key_label')} />
            <div className={Style['customize-url']}>
                <Form.Input disabled value={baseUrl} />
                <Form.Input value={form.widget_key} onChange={handleChange} maxLength={60} />
            </div>
            <span className={Style['input-length']}>
                <span>
                    {valueLength || 0}
                    {`/${maxLength}`}
                </span>
                {valueLength > 60 && <span className={Style['input-length-message']}>{t('ticket.rates.infos.name-too-long')}</span>}
            </span>
            <Form.FieldErrors errors={formErrors['widget_key'] ? [t(formErrors['widget_key'])] : ['']} />
        </Form.Field>
    );
}
